import React, { useState, useEffect } from "react";

import {
  Box,
  TextField,
  Typography,
  MenuItem,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  FormControlLabel,
  Button,
  Stack,
  RadioGroup,
  Radio,
  FormControl,
  InputLabel,
  Alert,
} from "@mui/material";

import Snackbar from "@mui/material/Snackbar";
import { useClientInfo, axiosInstance } from "../../utils/commonImports";
import InputAdornment from "@mui/material/InputAdornment";
import MyDatePicker from "../../components/MyDatePicker";
import CustomerDropdown from "../../components/CustomerDropdown";
import { createDocument } from "../../api/numberingApi";
import { useParams } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

import PreviewModal from "../../components/preview/PreviewModal";

import { numberToIndianWords } from "../../utils/numberToIndianWords";
import { normalizeDateAny } from "../../utils/dateUtils";

import ContractTariffPanel from "./ContractTariffPanel";
import dayjs from "dayjs";

// ================= GST Calculation Function =================
function calculateGstAmounts({
  tax_preference,
  place_of_supply,
  client_place_of_supply,
  taxable_amount,
  cgst_percent = 0,
  sgst_percent = 0,
  igst_percent = 0,
}) {
  let cgst = 0;
  let sgst = 0;
  let igst = 0;

  if (tax_preference === "Taxable") {
    if (place_of_supply === client_place_of_supply) {
      cgst = (taxable_amount * cgst_percent) / 100;
      sgst = (taxable_amount * sgst_percent) / 100;
    } else {
      igst = (taxable_amount * igst_percent) / 100;
    }
  }

  return { cgst, sgst, igst };
}

// export default function InvoiceFormAdd({ invoiceId }) {
export default function InvoiceFormAdd({
  invoiceId,
  editData,
  onCancel,
  onSuccess,
}) {
  const { clientId } = useClientInfo();
  const [clientDetails, setClientDetails] = useState({});
  const [filterType, setFilterType] = useState("all");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [customers, setCustomers] = useState([]);

  const [tripDuties, setTripDuties] = useState([]);
  const [selectedIndices, setSelectedIndices] = useState([]);
  const [loadingTrips, setLoadingTrips] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState("");

  const [rows, setRows] = useState([]);
  const [selectedAll, setSelectedAll] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState([]);
  const selectedRows = rows.filter((_, idx) => selectedIndex.includes(idx));

  const [vehicles, setVehicles] = useState([]);
  const [vehicleGroups, setVehicleGroups] = useState([]);

  const [form, setForm] = useState({
    number: "",
    date: "",
    reference: "",
    po_no: "",
    customerid: 0,
    customers: "",
    gst_treatment: "",
    tax_preference: "",
    customergstin: "",
    place_of_supply: "",
    cal_gst_parking_toll_permit: "",
    cal_gst_batta: "",
    cal_gst_others: "",
    payment_mode: "",
    client_place_of_supply: "",
    taxable_amount: 0,
    cgst_amount: 0,
    sgst_amount: 0,
    igst_amount: 0,
    gross_before_tax: 0,
    advance_amount: 0,
    voucher_advance_amount: 0,
    coin_adjust: 0,
    addition_amount: 0,
    discount_amount: 0,
    deduction_amount: 0,
    hsn_code: "996601",
    gst_notification: "",
    remarks: "",

    // any other fields you use...  vehicleid: null,
    vehicleNo: "",
    vehicleGroupId: null,
    vehicleGroupName: "",
    billing_type: "",
    periodFrom: "",
    periodTo: "",

    // contract rows from panel
    contractRows: {
      Days: { limit: 0, actual: 0, extra: 0, rate: 0, total: 0 },
      Hours: { limit: 0, actual: 0, extra: 0, rate: 0, total: 0 },
      Kms: { limit: 0, actual: 0, extra: 0, rate: 0, total: 0 },
    },
  });

  const { invoiceParam } = useParams(); // URL param like /invoice/:invoiceParam
  const existingDutyIds =
    editData?.trip_duties?.map((duty) => duty.trip_duty_id) || [];

  const [invoiceNumber, setInvoiceNumber] = useState(form.number);

  const [basic_amount, setBasic_amount] = useState(0);
  const [fuel_esc_amount, setFuel_esc_amount] = useState(0);
  const [escort_amount, setEscort_amount] = useState(0);
  const [batta_amount, setBatta_amount] = useState(0);
  const [parking_amount, setParking_amount] = useState(0);
  const [toll_amount, setToll_amount] = useState(0);
  const [permit_amount, setPermit_amount] = useState(0);
  const [others_amount, setOthers_amount] = useState(0);
  const [clientBanks, setClientBanks] = useState([]);

  const [duties, setDuties] = useState([]);
  const [billedDuties, setBilledDuties] = useState([]); // duties already billed
  const [unbilledDuties, setUnbilledDuties] = useState([]); // pending duties
  const [selectedDutyIds, setSelectedDutyIds] = useState([]); // checked ids in popup
  const [showDutySelector, setShowDutySelector] = useState(false); // popup
  const [selectedDuties, setSelectedDuties] = useState([]);

  // Voucher states
  const [vouchers, setVouchers] = useState([]);
  const [selectedVoucherIds, setSelectedVoucherIds] = useState([]);
  const [voucherSelectAll, setVoucherSelectAll] = useState(false);
  const [showVoucherTable, setShowVoucherTable] = useState(false);

  const currentInvoiceId = invoiceId || form?.invoiceid || editData?.invoiceid;

  // Determine edit mode based on currentInvoiceId
  const isEditMode = Boolean(currentInvoiceId);

  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [previewHTML, setPreviewHTML] = useState("");

  // contractRows state in parent (for Days / Hours / Kms)
  const defaultContractRows = {
    Days: { limit: 0, actual: 0, extra: 0, rate: 0, total: 0 },
    Hours: { limit: 0, actual: 0, extra: 0, rate: 0, total: 0 },
    Kms: { limit: 0, actual: 0, extra: 0, rate: 0, total: 0 },
  };

  const [contractTotals, setContractTotals] = useState(defaultContractRows);

  const [selectedTariffId, setSelectedTariffId] = useState(null);
  const [invoiceContract, setInvoiceContract] = useState(null);

  // const [showPrintConfirm, setShowPrintConfirm] = useState(false);
  // let tempInvoiceIdRef = useRef(null);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    // rows = your duties array
    const duties = selectedIndex.map((idx) => rows[idx]);

    setSelectedDuties(duties);
  }, [selectedIndex, rows]);

  useEffect(() => {
    const selectedRows = rows.filter((_, idx) => selectedIndex.includes(idx));
    // const selectedRows = tripDuties.filter((_, idx) => selectedIndex.includes(idx));

    // ⭐ BASIC AMOUNT CALCULATION
    // const calcBasic =
    //   Number(contractTotals?.rows?.Days?.total || 0) +
    //   Number(contractTotals?.rows?.Hours?.total || 0) +
    //   Number(contractTotals?.rows?.Kms?.total || 0);

    const calcBasic =
      Number(contractTotals?.Days?.total || 0) +
      Number(contractTotals?.Hours?.total || 0) +
      Number(contractTotals?.Kms?.total || 0);

    console.log("👉 CALCULATED BASIC AMOUNT:", calcBasic);

    setBasic_amount(calcBasic);
    // ⭐ All other amounts remain same
    setFuel_esc_amount(
      selectedRows.reduce(
        (acc, r) => acc + Number(r.trip_charges_fuel_esculation_amount || 0),
        0
      )
    );
    setEscort_amount(
      selectedRows.reduce(
        (acc, r) => acc + Number(r.trip_charges_escort_amount || 0),
        0
      )
    );
    setBatta_amount(
      selectedRows.reduce(
        (acc, r) => acc + Number(r.trip_charges_batta || 0),
        0
      )
    );
    setParking_amount(
      selectedRows.reduce(
        (acc, r) => acc + Number(r.trip_charges_parking || 0),
        0
      )
    );
    setToll_amount(
      selectedRows.reduce(
        (acc, r) => acc + Number(r.trip_charges_toll_fasttag || 0),
        0
      )
    );
    setPermit_amount(
      selectedRows.reduce(
        (acc, r) => acc + Number(r.trip_charges_permit || 0),
        0
      )
    );
    setOthers_amount(
      selectedRows.reduce(
        (acc, r) => acc + Number(r.trip_charges_others || 0),
        0
      )
    );
  }, [selectedIndex, rows, contractTotals]);

  // You should manage these states with hooks and input change handlers in real form
  const addition_amount = 0;
  const discount_amount = 0;
  const deduction_amount = 0;
  const hsn_code = "996601";
  const gst_notification = "";
  const remarks = "";

  // Assuming you have customerData loaded e.g. from API or state
  const customerData = {
    cal_gst_batta: "Yes", // or "No"
    cal_gst_others: "No",
    cal_gst_parking_toll_permit: "Yes",
  };

  // Calculate Gross amount before tax (you may want to build this in logic)
  const gross_before_tax =
    basic_amount +
    fuel_esc_amount +
    escort_amount +
    batta_amount +
    parking_amount +
    toll_amount +
    permit_amount +
    others_amount +
    addition_amount -
    deduction_amount -
    discount_amount;

  const taxable_amount =
    basic_amount +
    fuel_esc_amount +
    escort_amount +
    (form.cal_gst_batta === "Yes" ? batta_amount : 0) +
    (form.cal_gst_parking_toll_permit === "Yes"
      ? parking_amount + toll_amount + permit_amount
      : 0) +
    (form.cal_gst_others === "Yes" ? others_amount : 0) +
    addition_amount -
    discount_amount -
    deduction_amount;

  const paymentModes = [
    "Postpaid",
    "COD",
   
  ];

  useEffect(() => {
    if (!clientId) return;

    async function fetchClientData() {
      console.log("Client id inside fetchClientData() :", clientId);

      try {
        const res = await axiosInstance.get(`/api/clients/${clientId}`);

        console.log("🔵 API Client Response:", res.data);

        const client = res.data.client;

        console.log("🟣 Extracted Client Object:", client);

        setClientDetails(client);

        setForm((prev) => ({
          ...prev,
          client_place_of_supply: client.place_of_supply || "",
        }));
      } catch (error) {
        console.error("❌ Failed to fetch client details:", error);
      }
    }

    fetchClientData();
  }, [clientId]);

  useEffect(() => {
    if (!clientId) return;
    async function fetchCustomers() {
      try {
        const response = await axiosInstance.get("/api/customers", {
          params: { client_id: clientId },
        });
        setCustomers(response.data || []);
      } catch (error) {
        console.error("Error fetching customers:", error);
        setCustomers([]);
      }
    }
    fetchCustomers();
  }, [clientId]);

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [vehRes, groupRes] = await Promise.all([
          axiosInstance.get(`/api/vehicles`, {
            params: { client_id: clientId },
          }),

          axiosInstance.get("/api/components/category", {
            params: { type: "VehicleGroup", client_id: clientId },
          }),
        ]);

        setVehicles(vehRes.data || []);
        setVehicleGroups(groupRes.data || []);
      } catch (err) {
        console.error("Failed to load dropdown data", err);
      }
    };

    fetchDropdownData();
  }, [clientId]);

  const [igstPercent, setIgstPercent] = useState(0);
  const [cgstPercent, setCgstPercent] = useState(0);
  const [sgstPercent, setSgstPercent] = useState(0);

  useEffect(() => {
    if (!clientId) return;

    async function fetchGSTSettings() {
      try {
        const res = await axiosInstance.get(
          `/api/clients/${clientId}/gst-settings`
        );

        const gst = res.data?.gst || {};

        // Sync GST percent values
        setCgstPercent(gst.tax_rate_cgst || 0);
        setSgstPercent(gst.tax_rate_sgst || 0);
        setIgstPercent(gst.tax_rate_igst || 0);

        // Sync into form for NEW invoice
        if (!isEditMode) {
          setForm((prev) => ({
            ...prev,
            cgst_percent: gst.tax_rate_cgst || 0,
            sgst_percent: gst.tax_rate_sgst || 0,
            igst_percent: gst.tax_rate_igst || 0,
            hsn_code: gst.hsn_code || "",
            gst_notification: gst.gst_notification || "",
          }));
        }
      } catch (error) {
        console.error("Error fetching GST settings:", error);
      }
    }

    fetchGSTSettings();
  }, [clientId]);

  useEffect(() => {
    const { cgst, sgst, igst } = calculateGstAmounts({
      tax_preference: form.tax_preference,
      place_of_supply: form.place_of_supply,
      client_place_of_supply: form.client_place_of_supply,
      taxable_amount: Number(taxable_amount) || 0,
      cgst_percent: Number(form.cgst_percent) || 0,
      sgst_percent: Number(form.sgst_percent) || 0,
      igst_percent: Number(form.igst_percent) || 0,
    });

    setForm((prev) => ({
      ...prev,
      cgst_amount: cgst,
      sgst_amount: sgst,
      igst_amount: igst,
      taxable_amount,
    }));
  }, [
    taxable_amount,
    form.tax_preference,
    form.place_of_supply,
    form.client_place_of_supply,
    form.cgst_percent,
    form.sgst_percent,
    form.igst_percent,
  ]);

  // 1. Keep discount_amount synced with discount_percent & basic_amount
  useEffect(() => {
    const discountPercent = Number(form.discount_percent) || 0;
    const discountAmount = (basic_amount * discountPercent) / 100;
    if (discountAmount !== form.discount_amount) {
      setForm((prev) => ({ ...prev, discount_amount: discountAmount }));
    }
  }, [form.discount_percent, basic_amount]);

  // 2. Recalculate gross_before_tax and taxable_amount anytime amounts change
  useEffect(() => {
    const gross_before_tax =
      Number(basic_amount) +
      Number(fuel_esc_amount) +
      Number(escort_amount) +
      Number(batta_amount) +
      Number(parking_amount) +
      Number(toll_amount) +
      Number(permit_amount) +
      Number(others_amount) +
      Number(form.addition_amount || 0) -
      Number(form.deduction_amount || 0) -
      Number(form.discount_amount || 0);

    const taxable_amount =
      Number(basic_amount) +
      Number(fuel_esc_amount) +
      Number(escort_amount) +
      (form.cal_gst_batta === "Yes" ? Number(batta_amount) : 0) +
      (form.cal_gst_parking_toll_permit === "Yes"
        ? Number(parking_amount) + Number(toll_amount) + Number(permit_amount)
        : 0) +
      (form.cal_gst_others === "Yes" ? Number(others_amount) : 0) +
      Number(form.addition_amount || 0) -
      Number(form.deduction_amount || 0) -
      Number(form.discount_amount || 0);

    setForm((prev) => ({
      ...prev,
      gross_before_tax,
      taxable_amount,
    }));
  }, [
    basic_amount,
    fuel_esc_amount,
    escort_amount,
    batta_amount,
    parking_amount,
    toll_amount,
    permit_amount,
    others_amount,
    form.cal_gst_batta,
    form.cal_gst_parking_toll_permit,
    form.cal_gst_others,
    form.addition_amount,
    form.deduction_amount,
    form.discount_amount,
  ]);

  function roundCoinAdjust(value) {
    const integerPart = Math.floor(value);
    const fraction = value - integerPart;

    if (fraction < 0.5) {
      return integerPart; // round down to integer
    } else {
      return integerPart + 1; // round up to next integer
    }
  }

  useEffect(() => {
    const baseAmount =
      Number(form.gross_before_tax) +
      Number(form.cgst_amount) +
      Number(form.sgst_amount) +
      Number(form.igst_amount) -
      (Number(form.advance_amount) || 0) -
      (Number(form.voucher_advance_amount) || 0);

    if (baseAmount <= 0) return; // skip calculation

    // Calculate raw difference to round
    const difference = baseAmount - Math.floor(baseAmount);

    // Decide coin_adjust based on difference rounded by custom function
    const roundedAdjust = roundCoinAdjust(difference);

    // Calculate coin_adjust needed to bring baseAmount to an integer rounded as requested
    const newCoinAdjust = roundedAdjust - difference;

    setForm((prev) => ({ ...prev, coin_adjust: newCoinAdjust }));
  }, [
    form.gross_before_tax,
    form.cgst_amount,
    form.sgst_amount,
    form.igst_amount,
    form.advance_amount,
    form.voucher_advance_amount,
  ]);

  // Add to your state:
  const [netAmount, setNetAmount] = useState(0);

  useEffect(() => {
    let baseAmount = Number(form.gross_before_tax) || 0;

    const isRCM = form.gst_treatment === "Registered Business-Under RCM";

    // REGULAR GST → ADD GST AMOUNT
    if (!isRCM) {
      baseAmount +=
        Number(form.cgst_amount) +
        Number(form.sgst_amount) +
        Number(form.igst_amount);
    }

    // RCM → DO NOT ADD GST (GST only shown inside invoice)
    // baseAmount stays same

    // SUBTRACT ADVANCES
    baseAmount -=
      Number(form.advance_amount || 0) +
      Number(form.voucher_advance_amount || 0);

    // ADD COIN ADJUST
    baseAmount += Number(form.coin_adjust || 0);

    setNetAmount(baseAmount);
  }, [
    form.gross_before_tax,
    form.cgst_amount,
    form.sgst_amount,
    form.igst_amount,
    form.advance_amount,
    form.voucher_advance_amount,
    form.coin_adjust,
    form.gst_treatment,
  ]);

  // Effect to keep selectedDutyIds in sync with selectedIndex/selectedRows
  useEffect(() => {
    const ids = selectedIndex.map((i) => rows[i]?.trip_duty_id).filter(Boolean);
    setSelectedDutyIds(ids);
  }, [selectedIndex, rows]);

  useEffect(() => {
    if (invoiceContract) {
      setForm((prev) => ({
        ...prev,
        vehicleGroupId: invoiceContract.vehicle_group_id,
        vehicleGroupName: invoiceContract.vehicle_group_name,
      }));
    }
  }, [invoiceContract]);

  useEffect(() => {
    const finalCustomerId = form.customerid;

    // Wait until we know the invoiceId when editing, and vehicleGroupId present
    if (!clientId || !finalCustomerId || !form.vehicleGroupId) {
      console.log(
        "⏳ Waiting for client/customer/vehicleGroup (or invoice) before fetching duties",
        {
          clientId,
          finalCustomerId,
          vehicleGroupId: form.vehicleGroupId,
          invoiceParam,
        }
      );
      return;
    }

    const fetchTripDuties = async () => {
      try {
        setLoadingTrips(true);

        const invoiceParam =
          form.invoiceid && form.invoiceid !== "0" ? form.invoiceid : "new";

        console.log("🚀 Fetching duties with:", {
          client_id: clientId,
          customer_id: finalCustomerId,
          vehicle_group_id: form.vehicleGroupId,
        });

        const res = await axiosInstance.get(
          `/api/invoices/${invoiceParam}/contractduties`,
          {
            params: {
              client_id: clientId,
              customer_id: finalCustomerId,
              vehicle_group_id: form.vehicleGroupId,
            },
          }
        );

        console.log("📥 Duties API response:", res.data);

        const { selected = [], pending = [] } = res.data;

        if (invoiceParam !== "new") {
          setRows(selected);
          setSelectedIndex(selected.map((_, index) => index));
        } else {
          const normalizedPending = pending.map((d) => ({
            ...d,
            duty_id: d.trip_duty_id || d.id,
          }));

          setRows(normalizedPending);
          setSelectedIndex([]);
        }
      } catch (error) {
        console.error("Error fetching trip duties:", error);
        setRows([]);
        setSelectedIndex([]);
      } finally {
        setLoadingTrips(false);
      }
    };

    fetchTripDuties();
  }, [
    form.customerid,
    form.vehicleGroupId, // ⭐ REQUIRED
    form.invoiceid,
    clientId,
  ]);

  useEffect(() => {
    async function loadBanks() {
      try {
        const response = await axiosInstance.get(
          `/api/client-banks/${clientId}`
        );

        setClientBanks(response.data || []);
        console.log("BANKS LOADED:", response.data);
      } catch (err) {
        console.error("Failed to load client banks", err);
      }
    }

    loadBanks();
  }, [clientId]);

  useEffect(() => {
    if (!form.customerid || !clientId) return;

    async function loadLedgerId() {
      try {
        console.log("🔍 Fetching Ledger ID for customer:", form.customerid);

        const res = await axiosInstance.get("/api/customers/ledger-id", {
          params: { client_id: clientId, customer_id: form.customerid },
        });

        console.log("📌 Ledger ID received:", res.data.ledger_id);

        setForm((prev) => ({
          ...prev,
          customer_ledger_id: res.data.ledger_id,
        }));
      } catch (err) {
        console.error("❌ Ledger Load Error:", err);
      }
    }

    loadLedgerId();
  }, [form.customerid, clientId]);

  // inside your component
  useEffect(() => {
    if (showVoucherTable) return;
    if (!form.customer_ledger_id || !clientId) return;

    async function loadVouchersForEdit() {
      try {
        console.log("📌 Loading vouchers for invoice form");

        // NEW invoice → only pending vouchers (same as before)
        if (!form.invoiceid) {
          const pendingRes = await axiosInstance.get("/api/vouchers/pending", {
            params: {
              client_id: clientId,
              ledger_id: form.customer_ledger_id,
            },
          });

          const pending = pendingRes.data || [];
          // Normalize shape: ensure voucher_id present
          const normalizedPending = pending.map((p) => ({
            ...p,
            voucher_id: p.voucher_id || p.id,
          }));

          setVouchers(normalizedPending);
          setSelectedVoucherIds([]);
          setShowVoucherTable(Boolean(normalizedPending.length));
          return;
        }

        // EDIT invoice → load only selected initially
        const selectedRes = await axiosInstance.get("/api/vouchers/selected", {
          params: {
            client_id: clientId,
            invoice_id: form.invoiceid,
            customer_id: form.customer_ledger_id,
          },
        });

        const selected = selectedRes.data || [];
        const normalizedSelected = selected.map((s) => ({
          ...s,
          voucher_id: s.voucher_id || s.id,
        }));

        setVouchers(normalizedSelected);
        // Selected ids MUST be voucher_id
        setSelectedVoucherIds(normalizedSelected.map((v) => v.voucher_id));
        setShowVoucherTable(normalizedSelected.length > 0);
      } catch (err) {
        console.error("❌ Voucher Load Error:", err);
      }
    }

    loadVouchersForEdit();
  }, [form.customer_ledger_id, form.invoiceid, clientId]);

  // -------------------------------
  // Select / Unselect Single Voucher
  // -------------------------------
  const handleVoucherSelect = (voucherId) => {
    const id = Number(voucherId);
    console.log("HANDLE CALL → id:", id);

    setSelectedVoucherIds((prev) => {
      const updated = prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id];

      console.log("STATE UPDATE REQUEST → updated:", updated);

      // ⭐ Update total immediately when selection changes
      updateVoucherTotal(updated);

      return updated;
    });
  };

  // -------------------------------
  // Select / Unselect ALL Vouchers
  // -------------------------------
  const handleVoucherSelectAll = () => {
    if (voucherSelectAll) {
      setVoucherSelectAll(false);
      setSelectedVoucherIds([]);
      updateVoucherTotal([]);
    } else {
      const allIds = vouchers
        .map((v) => parseInt(v.voucher_id || v.id, 10)) // ⭐ ensure integer
        .filter((n) => !isNaN(n));

      setVoucherSelectAll(true);
      setSelectedVoucherIds(allIds);
      updateVoucherTotal(allIds);
    }
  };

  const handleOpenVoucherTable = async () => {
    try {
      console.log("🟦 +Voucher clicked → loading pending + selected vouchers");

      if (!clientId || !form.customer_ledger_id) {
        console.log("❌ Missing clientId or customer_ledger_id");
        return;
      }

      // 1) Pending
      const pendingRes = await axiosInstance.get("/api/vouchers/pending", {
        params: {
          client_id: clientId,
          ledger_id: form.customer_ledger_id,
        },
      });
      const pending = pendingRes.data || [];
      const normalizedPending = pending.map((p) => ({
        ...p,
        voucher_id: p.voucher_id || p.id,
      }));

      // 2) Selected (if edit)
      let selected = [];
      if (form.invoiceid) {
        const selectedRes = await axiosInstance.get("/api/vouchers/selected", {
          params: {
            client_id: clientId,
            invoice_id: form.invoiceid,
            customer_id: form.customer_ledger_id,
          },
        });
        selected = selectedRes.data || [];
      }
      const normalizedSelected = selected.map((s) => ({
        ...s,
        voucher_id: s.voucher_id || s.id,
      }));

      // 3) Merge: keep selected first, then pending (avoid duplicates by voucher_id)
      const selectedMap = new Map(
        normalizedSelected.map((s) => [s.voucher_id, s])
      );
      normalizedPending.forEach((p) => {
        if (!selectedMap.has(p.voucher_id)) selectedMap.set(p.voucher_id, p);
      });

      const merged = Array.from(selectedMap.values());

      console.log("🟢 Final merged voucher list:", merged);

      setVouchers(merged);

      // Keep previously selected vouchers that are still present; otherwise only selected from API
      const currentlySelected =
        normalizedSelected.length > 0
          ? normalizedSelected.map((v) => v.voucher_id)
          : [];
      setSelectedVoucherIds(currentlySelected);

      setShowVoucherTable(true);
    } catch (err) {
      console.error("❌ Error loading voucher table:", err);
    }
  };

  // -------------------------------
  // Recalculate Total Advance
  // -------------------------------
  const updateVoucherTotal = (ids) => {
    const total = vouchers
      .filter((v) => ids.includes(v.voucher_id || v.id))
      .reduce((sum, v) => sum + Number(v.credit_amount || 0), 0);

    setForm((prev) => ({ ...prev, voucher_advance_amount: total }));
  };

  useEffect(() => {
    if (previewHTML) {
      setShowPreview(true);
    }
  }, [previewHTML]);

  const handleFilterChange = (e) => setFilterType(e.target.value);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectAll = (e) => {
    setSelectedAll(e.target.checked);
    setSelectedIndex(e.target.checked ? rows.map((_, idx) => idx) : []);
  };

  const handleSelectRow = (idx) => {
    if (selectedIndex.includes(idx)) {
      setSelectedIndex(selectedIndex.filter((i) => i !== idx));
    } else {
      setSelectedIndex([...selectedIndex, idx]);
    }
  };

  // --------------------
  // +DUTY POPUP HANDLERS
  // --------------------

  const handleAddDutyClick = async () => {
    try {
      console.log("🟦 +Duty clicked → loading pending + selected duties");

      const invoiceParam =
        form.invoiceid && form.invoiceid !== "0" ? form.invoiceid : "new";

      const dutyType = form.duty || form.invoice_type || "Contract";
      // 🔥 adjust based on your actual field name

      const res = await axiosInstance.get(
        `/api/invoices/${invoiceParam}/contractduties`,
        {
          params: {
            client_id: clientId,
            customer_id: form.customerid,
            vehicle_group_id: form.vehicleGroupId, // if needed
          },
        }
      );

      const billed = res.data.selected || [];
      const pending = res.data.pending || [];

      console.log("RAW Pending Response:", res.data.pending);
      console.log("📘 Billed:", billed);
      console.log("📙 Pending:", pending);

      // -----------------------------------------------------
      // NORMALIZE IDs + OPEN_DATE BEFORE USING IN TABLE
      // -----------------------------------------------------
      const normalizedBilled = billed.map((d) => ({
        ...d,
        duty_id: d.trip_duty_id || d.id,
        open_date: normalizeDateAny(d.open_date),
      }));

      const normalizedPending = pending.map((d) => ({
        ...d,
        duty_id: d.trip_duty_id || d.id,
        open_date: normalizeDateAny(d.open_date),
      }));

      // update originals
      setBilledDuties(normalizedBilled);
      setUnbilledDuties(normalizedPending);

      setSelectedDutyIds(normalizedBilled.map((d) => d.duty_id));

      // -----------------------------------------------------
      // MERGE & MAP TO FINAL TABLE ROWS
      // -----------------------------------------------------
      const merged = [...normalizedBilled, ...normalizedPending];

      console.log("🟢 FINAL TABLE ROWS:", merged);

      setRows(merged);

      setShowDutySelector(true);
    } catch (err) {
      console.log("❌ Error loading duties:", err);
    }
  };

  ///-------------- Saving Invoice Data to invoices Db -----------------
  useEffect(() => {
    if (editData) {
      // ⭐ ADD THIS LINE
      setForm({
        invoiceid: editData.invoiceid || editData.invoiceId || "", // Added invoiceid here
        client_id: editData.client_id || "",
        fyid: editData.fyid || "",
        bill_type: editData.bill_type || "",
        number: editData.invoice_number || "",
        date: editData.invoice_date ? new Date(editData.invoice_date) : null,
        customerid: editData.customer_id || "",
        reference: editData.reference || "",
        po_no: editData.po_no || "",
        payment_mode: editData.payment_mode || "",
        period_from: editData.period_from || null,
        period_to: editData.period_to || null,
        header: editData.header || "",
        basic_amount: Number(editData.basic_amount) || 0,
        escort_amount: Number(editData.escort_amount) || 0,
        batta_amount: Number(editData.batta_amount) || 0,
        parking_amount: Number(editData.parking_amount) || 0,
        others_amount: Number(editData.others_amount) || 0,
        permit_amount: Number(editData.permit_amount) || 0,
        toll_amount: Number(editData.toll_amount) || 0,
        fuel_ex_remarks: editData.fuel_ex_remarks || "",
        fuel_esc_amount: Number(editData.fuel_esc_amount) || 0,
        addition_remarks: editData.addition_remarks || "",
        addition_amount: Number(editData.addition_amount) || 0,
        deduction_remarks: editData.deduction_remarks || "",
        deduction_amount: Number(editData.deduction_amount) || 0,
        discount_percent: Number(editData.discount_percent) || 0,
        discount_amount: Number(editData.discount_amount) || 0,
        place_of_supply: editData.place_of_supply || "",
        tax_preference: editData.tax_preference || "",
        gst_treatment_id: editData.gst_treatment_id || null,
        gst_treatment: editData.gst_treatment || "",
        gst_notification: editData.gst_notification || "",
        hsn_code: editData.hsn_code || "",
        igst_percent: Number(editData.igst_percent) || 0,
        cgst_percent: Number(editData.cgst_percent) || 0,
        sgst_percent: Number(editData.sgst_percent) || 0,
        cal_gst_parking_toll_permit: editData.cal_gst_parking_toll_permit || "",
        cal_gst_batta: editData.cal_gst_batta || "",
        cal_gst_others: editData.cal_gst_others || "",
        igst_amount: Number(editData.igst_amount) || 0,
        cgst_amount: Number(editData.cgst_amount) || 0,
        sgst_amount: Number(editData.sgst_amount) || 0,
        advance_amount: Number(editData.advance_amount) || 0,
        voucher_advance_amount: Number(editData.voucher_advance_amount) || 0,
        coin_adjust: Number(editData.coin_adjust) || 0,
        net_amount: Number(editData.net_amount) || 0,
        word_amount: editData.word_amount || "",
        no_of_tripsheets: Number(editData.no_of_tripsheets) || 0,
        naration: editData.naration || "",
        annexureid: editData.annexureid || null,
        client_place_of_supply: editData.client_place_of_supply || "",

        // Add other fields as needed
      });
    }
  }, [editData]);

  // 🔍 FETCH INVOICE CONTRACT (from invoices_contract table)
  useEffect(() => {
    if (!editData?.invoiceid) return;

    const fetchInvoiceContract = async () => {
      try {
        const res = await axiosInstance.get(
          `/api/invoices/contract/${editData.invoiceid}`,
          { params: { client_id: clientId } }
        );

        if (res.data?.contract) {
          console.log("📌 Invoice Contract Loaded:", res.data.contract);
          setInvoiceContract(res.data.contract);
        } else {
          console.log("⚠ No invoice contract found");
        }
      } catch (err) {
        console.error("❌ Error loading invoice contract:", err);
      }
    };

    fetchInvoiceContract();
  }, [editData, clientId]);

  // ------------------------------------------------------
  // MAIN TRIP MAPPING FUNCTION (self-contained)
  // ------------------------------------------------------
  function mapTripDuty(t) {
    function showDash(val) {
      if (val === null || val === undefined) return "-";
      if (val === "") return "-";
      if (isNaN(val)) return "-";
      return Number(val);
    }

    function showNumber(val) {
      return val && !isNaN(val) ? Number(val) : 0;
    }

    function showAmount(val) {
      const num = Number(val);
      return num > 0 ? num : "-";
    }

    function formatSlabDisplay(item) {
      const itemDuty = (item.duty || "").trim();

      if (itemDuty === "Outstation" || itemDuty === "OSDayRate") {
        const days = showNumber(item.trip_charges_days_used);
        const minKm = showNumber(item.trip_charges_slab_km);
        return days > 0 && minKm > 0 ? `${days} / ${days * minKm}` : "-";
      }

      const hours = showNumber(item.trip_charges_slab_hour);
      const kms = showNumber(item.trip_charges_slab_km);
      return hours > 0 || kms > 0 ? `${hours} / ${kms}` : "-";
    }

    // ---------------- BATTA ----------------
    let dutyVal = (t.duty || "").trim();

    // Local batta
    let batta_local =
      dutyVal === "Contract" ? showNumber(t.trip_charges_local_batta) : 0;

    // Outstation Day Batta
    let batta_os_day =
      dutyVal !== "Contract"
        ? showNumber(t.trip_charges_os_batta_total_amount)
        : 0;

    console.log("Night Batta:", t.trip_charges_os_night_batta_total_amount);

    // Outstation Night Batta  ⭐ NEW
    let batta_os_night =
      dutyVal !== "Contract"
        ? showNumber(t.trip_charges_os_night_batta_total_amount)
        : 0;

    // Total batta for this duty
    let batta_main = batta_local + batta_os_day + batta_os_night;

    const extra_hour = showNumber(t.trip_charges_extra_hour);
    const extra_hour_rate = showNumber(t.trip_charges_slab_extra_hour_rate);
    const extra_km = showNumber(t.trip_charges_extra_kms);
    const extra_km_rate = showNumber(t.trip_charges_slab_extra_km_rate);

    // ---------------- DISPLAY FIELDS ----------------
    const displayExtraHours =
      dutyVal === "Outstation" || dutyVal === "OSDayRate"
        ? "-"
        : extra_hour > 0 && extra_hour_rate > 0
        ? `${extra_hour} × ${extra_hour_rate}`
        : "-";

    const displayExtraHoursAmt =
      dutyVal === "Outstation" || dutyVal === "OSDayRate"
        ? "-"
        : showAmount(t.trip_charges_extra_hour_amount);

    const displayExtraKms =
      dutyVal === "Outstation" || dutyVal === "OSDayRate"
        ? "-"
        : extra_km > 0 && extra_km_rate > 0
        ? `${extra_km} × ${extra_km_rate}`
        : "-";

    const displayExtraKmsAmt =
      dutyVal === "Outstation" || dutyVal === "OSDayRate"
        ? "-"
        : showAmount(t.trip_charges_extra_km_amount);

    // ---------------- PARKING / TOLL / PERMIT ----------------
    const parkingNum = showNumber(t.trip_charges_parking);
    const tollNum = showNumber(t.trip_charges_toll_fasttag);
    const permitNum = showNumber(t.trip_charges_permit);
    const othersNum = showNumber(t.trip_charges_others);

    function toHHMM(timeStr) {
      if (!timeStr) return "-";
      // timeStr looks like "06:00:00" → we want only "06:00"
      return timeStr.substring(0, 5);
    }

    // ---------------- RETURN FINAL ----------------
    return {
      serial: t.serial,
      duty: t.duty,
      tripsheet_number: t.tripsheet_number,

      open_date: t.open_date
        ? new Date(normalizeDateAny(t.open_date)).toLocaleDateString("en-GB")
        : "-",
      close_date: t.close_date
        ? new Date(normalizeDateAny(t.close_date)).toLocaleDateString("en-GB")
        : "-",

      vehicle_no: t.is_vendor_tripsheet ? t.vendor_vehicle_no : t.vehicleid,
      vehicle_type: t.assigned_vehicle_group_name || "-",

      // TIMINGS
      open_time: toHHMM(t.open_time),
      close_time: toHHMM(t.close_time),

      // ⭐ KM READINGS — YOU MISSED THIS EARLIER
      open_km_reading: t.open_km_reading ?? "-",
      close_km_reading: t.close_km_reading ?? "-",

      hours_used: t.trip_charges_hours_used ?? t.hours ?? "-",
      kms_used: t.trip_charges_kms_used ?? t.kms ?? "-",

      fuel: showNumber(t.trip_charges_fuel_esculation_amount),
      escort: showNumber(t.trip_charges_escort_amount),

      days: showDash(t.trip_charges_days_used),
      hours: showDash(t.trip_charges_hours_used),
      kms: showDash(t.trip_charges_kms_used),

      slab_display: formatSlabDisplay(t),

      // NUMERIC VALUES (for totals)
      slab_rate: showNumber(
        dutyVal === "Outstation"
          ? t.trip_charges_slab_os_rate
          : t.trip_charges_slab_rate
      ),

      slab_amount: showNumber(t.trip_charges_charge_amount),
      extra_hour_amount: showNumber(t.trip_charges_extra_hour_amount),
      extra_km_amount: showNumber(t.trip_charges_extra_km_amount),

      // DISPLAY VALUES (for table)
      extra_hours_display: displayExtraHours,
      extra_hour_amount_display: displayExtraHoursAmt,

      extra_kms_display: displayExtraKms,
      extra_km_amount_display: displayExtraKmsAmt,

      batta_local: showNumber(batta_local),
      batta_os_day: showNumber(batta_os_day),
      batta_os_night: showNumber(batta_os_night),

      // This is what HTML uses as N.Batta
      nbatta: showNumber(batta_os_night),

      batta_main: showNumber(batta_main),

      parking: parkingNum,
      toll: tollNum,
      permit: permitNum,
      others: othersNum,

      escort_amount: showNumber(t.trip_charges_escort_amount),

      advance:
        showNumber(t.trip_charges_advance) +
        showNumber(t.trip_charges_booking_advance),

      trip_net_amount:
        showNumber(t.trip_charges_charge_amount) +
        showNumber(t.trip_charges_extra_hour_amount) +
        showNumber(t.trip_charges_extra_km_amount) +
        showNumber(batta_main) +
        parkingNum +
        tollNum +
        permitNum +
        othersNum +
        showNumber(t.trip_charges_escort_amount),

      trip_advance:
        showNumber(t.trip_charges_advance) +
        showNumber(t.trip_charges_booking_advance),
    };
  }

  function mapBankDetails(clientBanks) {
    const bank = clientBanks.find((b) => b.is_primary) || clientBanks[0] || {};

    return {
      bank_name: bank.bank_name || "",
      account_number: bank.account_number || "",
      ifsc: bank.ifsc_code || "", // ✔ now correct
      branch: bank.branch || "",
      account_holder: bank.account_holder_name || "",
    };
  }

  const handlePreviewClose = () => {
    setShowPreview(false);

    // If user confirmed print earlier, now close the invoice also
    if (onSuccess) onSuccess();
  };

  const handleSave = async () => {
    try {
      if (!clientId) {
        setSnackbar({
          open: true,
          message: "Client ID missing",
          severity: "error",
        });
        return;
      }
      if (!form) {
        setSnackbar({
          open: true,
          message: "Form data missing",
          severity: "error",
        });
        return;
      }

      // ---------------------------------------------------------
      // FIX: SAFE ROWS TO PREVENT undefined.limit ERROR
      // ---------------------------------------------------------
      const safeRows = {
        Days: rows?.Days || {
          limit: 0,
          actual: 0,
          extra: 0,
          rate: 0,
          total: 0,
        },
        Hours: rows?.Hours || {
          limit: 0,
          actual: 0,
          extra: 0,
          rate: 0,
          total: 0,
        },
        Kms: rows?.Kms || {
          limit: 0,
          actual: 0,
          extra: 0,
          rate: 0,
          total: 0,
        },
      };

      let invoiceNumber = form.number;

      // -----------------------------
      // 🟦 Generate invoice number
      // -----------------------------
      if (!form.invoiceid) {
        try {
          const createdDoc = await createDocument(
            clientId,
            "Invoice",
            "Invoice Document"
          );
          invoiceNumber = createdDoc.document_number;
        } catch (err) {
          console.error("Error generating invoice number:", err);
          setSnackbar({
            open: true,
            message: "Failed to generate Invoice number",
            severity: "error",
          });
          return;
        }
      }

      const sanitize = (val) => (val === "" ? null : val);

      const invoiceData = {
        ...form,
        client_id: clientId,
        fyid: 1,
        bill_type: "Contract",

        invoice_number: invoiceNumber,
        invoice_date: form.date
          ? new Date(form.date).toISOString().slice(0, 10)
          : null,

        customer_id: sanitize(form.customerid),
        basic_amount,
        escort_amount,
        batta_amount,
        parking_amount,
        others_amount,
        permit_amount,
        toll_amount,
        fuel_esc_amount,
        addition_amount: sanitize(form.addition_amount),
        deduction_amount: sanitize(form.deduction_amount),
        discount_percent: sanitize(form.discount_percent),
        discount_amount: sanitize(form.discount_amount),
        net_amount: netAmount,

        voucher_ids: selectedVoucherIds || [],
        voucher_advance_amount: form.voucher_advance_amount || 0,

        is_sentmail: false,
        sentemailid: "",
        is_printed: false,
        is_cancelled: false,
        is_deleted: false,
        client_place_of_supply: sanitize(form.client_place_of_supply),
        place_of_supply: sanitize(form.place_of_supply),
        po_no: sanitize(form.po_no),
        payment_mode: sanitize(form.payment_mode),
        gst_treatment_id: form.gst_treatment_id,
        gst_notification: form.gst_notification,
      };

      let invoiceid;

      // -----------------------------
      // SAVE / UPDATE
      // -----------------------------
      try {
        if (form.invoiceid) {
          await axiosInstance.put(
            `/api/invoices/${form.invoiceid}`,
            invoiceData,
            { params: { client_id: clientId } }
          );
          invoiceid = form.invoiceid;

          setSnackbar({
            open: true,
            message: "Invoice Updated Successfully",
            severity: "success",
          });
        } else {
          const response = await axiosInstance.post(
            "/api/invoices",
            invoiceData,
            { params: { client_id: clientId } }
          );

          invoiceid = response.data.invoiceId || response.data.invoiceid;

          setSnackbar({
            open: true,
            message: "Invoice Saved Successfully",
            severity: "success",
          });

          setForm((prev) => ({ ...prev, invoiceid }));
        }
      } catch (err) {
        console.error("Error saving invoice:", err.response || err);
        setSnackbar({
          open: true,
          message:
            "Error saving invoice: " +
            (err.response?.data?.error || err.message || "Unknown error"),
          severity: "error",
        });
        return;
      }

      /* ============================================================
 ⭐ SAVE CONTRACT TARIFF PANEL (USES contractTotals)
============================================================ */
      try {
        console.log("🔥 FINAL contractRows at SAVE:", form.contractRows);

        // 🔥 DEFAULT VALUES (fallback safety)
        const defaultContractRows = {
          Days: { limit: 0, actual: 0, extra: 0, rate: 0, total: 0 },
          Hours: { limit: 0, actual: 0, extra: 0, rate: 0, total: 0 },
          Kms: { limit: 0, actual: 0, extra: 0, rate: 0, total: 0 },
        };

        // 🔥 FIX: Always use form.contractRows (most accurate)
        const safeRows =
          form.contractRows && form.contractRows.Days
            ? form.contractRows
            : defaultContractRows;

        const payload = {
          invoice_id: invoiceid,

          vehicle_id: form.vehicleid,
          vehicle_number: form.vehicleNo || "", // 🔥 FIXED

          contract_bill_type: form.billing_type,

          vehicle_group_id: form.vehicleGroupId,
          vehicle_group_name: form.vehicleGroupName,

          // LIMITS
          limit_days: safeRows.Days.limit,
          limit_hrs: safeRows.Hours.limit,
          limit_kms: safeRows.Kms.limit,

          limit_charges: safeRows.Days.total,
          limit_day_charges: safeRows.Days.rate,
          limit_extra_km_rate: safeRows.Kms.rate,
          limit_extra_hr_rate: safeRows.Hours.rate,

          // CUSTOMER USED VALUES
          customer_days: safeRows.Days.actual,
          customer_hrs: safeRows.Hours.actual,
          customer_kms: safeRows.Kms.actual,
          customer_charge_amount: safeRows.Days.total,

          customer_extra_days: safeRows.Days.extra,
          customer_extra_days_amount: safeRows.Days.extra * safeRows.Days.rate,

          customer_extra_hrs: safeRows.Hours.extra,
          customer_extra_hrs_amount: safeRows.Hours.total,

          customer_extra_kms: safeRows.Kms.extra,
          customer_extra_kms_amount: safeRows.Kms.total,

          // VEHICLE LIMITS
          vehicle_limit_days: safeRows.Days.limit,
          vehicle_limit_hrs: safeRows.Hours.limit,
          vehicle_limit_kms: safeRows.Kms.limit,
          vehicle_limit_charges: safeRows.Days.total,

          // VEHICLE ACTUAL
          vehicle_actual_days: safeRows.Days.actual,
          vehicle_actual_hrs: safeRows.Hours.actual,
          vehicle_actual_kms: safeRows.Kms.actual,

          vehicle_charges_amount:
            safeRows.Days.total + safeRows.Hours.total + safeRows.Kms.total,

          // EXTRA VALUES
          vehicle_extra_days: safeRows.Days.extra,
          vehicle_extra_hrs: safeRows.Hours.extra,
          vehicle_extra_kms: safeRows.Kms.extra,

          vehicle_hrs_amount: safeRows.Hours.total,
          vehicle_kms_amount: safeRows.Kms.total,
          vehicle_days_amount: safeRows.Days.total,

          // DATE RANGE
          from_date: form.periodFrom,
          to_date: form.periodTo,
        };

        await axiosInstance.post("/api/invoices/contract/save", payload, {
          params: { client_id: clientId },
        });
      } catch (err) {
        console.error("❌ CONTRACT SAVE ERROR:", err);
      }

      // 1️⃣ Build selected duty IDs from current table
      const selectedDutyIdsFromTable = (selectedIndex || [])
        .map((i) => rows[i]?.trip_duty_id)
        .filter((id) => Number.isInteger(id));

      // 2️⃣ Fetch currently linked contract duties from server
      let currentlyLinkedIds = [];
      try {
        console.log("📌 Fetching currently linked contract duties...");

        const linkedResponse = await axiosInstance.get(
          `/api/invoices/${invoiceid}/contractduties`,
          {
            params: {
              client_id: clientId,
              customer_id: form.customerid,
              vehicle_group_id: form.vehicleGroupId, // 🔥 include group filter
            },
          }
        );

        const payload = linkedResponse.data;

        if (Array.isArray(payload)) {
          currentlyLinkedIds = payload
            .map((d) => d.trip_duty_id)
            .filter(Number.isInteger);
        } else if (payload && Array.isArray(payload.selected)) {
          currentlyLinkedIds = payload.selected
            .map((d) => d.trip_duty_id)
            .filter(Number.isInteger);
        } else {
          currentlyLinkedIds = [];
        }

        console.log("🔵 currentlyLinkedIds:", currentlyLinkedIds);
      } catch (err) {
        console.error("❌ Error fetching linked contract duties:", err);
        currentlyLinkedIds = [];
      }

      // 3️⃣ Determine which need UNLINK (currently linked but now unchecked)
      const dutyTripIdsToUnlink = currentlyLinkedIds.filter(
        (id) => !selectedDutyIdsFromTable.includes(id)
      );

      const validUnlinkIds = dutyTripIdsToUnlink.filter((id) =>
        Number.isInteger(id)
      );

      console.log("❌ To UNLINK:", validUnlinkIds);

      if (validUnlinkIds.length > 0) {
        try {
          await axiosInstance.post(`/api/invoices/trip-duties/update-invoice`, {
            invoiceid: null, // unassign from invoice
            duty_trip_ids: validUnlinkIds,
            client_id: clientId,
          });
          console.log("✅ Unlinked successfully");
        } catch (err) {
          console.error("❌ Error unlinking contract duties:", err);
        }
      }

      // 4️⃣ Determine which need LINK (checked now but not previously linked)
      const validSelectedIds = selectedDutyIdsFromTable.filter((id) =>
        Number.isInteger(id)
      );

      console.log("🔗 To LINK:", validSelectedIds);

      if (validSelectedIds.length > 0) {
        try {
          await axiosInstance.post(`/api/invoices/trip-duties/update-invoice`, {
            invoiceid, // assign to invoice
            duty_trip_ids: validSelectedIds,
            client_id: clientId,
          });
          console.log("✅ Linked successfully");
        } catch (err) {
          console.error("❌ Error linking contract duties:", err);
        }
      }

      /* ============================================================
       VOUCHER LINKING
    ============================================================ */
      try {
        console.log("🔍 Fetching previously linked vouchers...");
        const selectedRes = await axiosInstance.get("/api/vouchers/selected", {
          params: {
            client_id: clientId,
            invoice_id: invoiceid,
            customer_id: form.customerid,
          },
        });

        const previouslyLinked = (selectedRes.data || []).map(
          (v) => v.voucher_id || v.id
        );

        const prevSet = previouslyLinked
          .map((x) => parseInt(x, 10))
          .filter((x) => !isNaN(x));

        const newSet = (selectedVoucherIds || [])
          .map((x) => parseInt(x, 10))
          .filter((x) => !isNaN(x));

        const finalVoucherIds = Array.from(new Set(newSet));

        const updateRes = await axiosInstance.post(
          "/api/vouchers/update-linked-vouchers",
          {
            invoice_id: invoiceid,
            voucher_ids: finalVoucherIds,
            customer_id: form.customerid,
            ledger_id: form.customer_ledger_id,
          }
        );
      } catch (err) {
        console.error("❌ Error linking vouchers:", err);
        setSnackbar({
          open: true,
          message: "Voucher linking failed",
          severity: "error",
        });
        return;
      }

      // -----------------------------------------------------
      // PREVIEW (unchanged)
      // -----------------------------------------------------
      try {
        // const previewTrips = await axiosInstance.get(
        //   `/api/invoices/${invoiceid}/tripduties`,
        //   {
        //     params: { client_id: clientId, customer_id: form.customerid },
        //   }
        // );
        const previewTrips = await axiosInstance.get(
          `/api/invoices/${invoiceid}/contractduties`,
          {
            params: {
              client_id: clientId,
              customer_id: form.customerid,
              vehicle_group_id: form.vehicleGroupId,
            },
          }
        );

        const payload = previewTrips.data;
        const previewSelectedArray = Array.isArray(payload)
          ? payload
          : payload?.selected || [];

        const mappedTrips = previewSelectedArray.map((t, i) =>
          mapTripDuty({ ...t, serial: i + 1 })
        );

        let basicTotal = 0;
        let battaTotal = 0;
        let parkingTotal = 0;
        let tollTotal = 0;
        let permitTotal = 0;
        let othersTotal = 0;
        let escortTotal = 0;
        let advanceTotal = 0;
        let netTotal = 0;
        let grossTotal = 0;

        mappedTrips.forEach((t) => {
          const basic =
            Number(t.slab_amount || 0) +
            Number(t.extra_hour_amount || 0) +
            Number(t.extra_km_amount || 0);

          basicTotal += basic;

          battaTotal += Number(t.batta_main || 0);
          parkingTotal += Number(t.parking || 0);
          tollTotal += Number(t.toll || 0);
          permitTotal += Number(t.permit || 0);
          othersTotal += Number(t.others || 0);
          escortTotal += Number(t.escort_amount || 0);
          advanceTotal += Number(t.advance || 0);
          netTotal += Number(t.net_amount || 0);

          grossTotal +=
            basic +
            Number(t.batta_main || 0) +
            Number(t.parking || 0) +
            Number(t.toll || 0) +
            Number(t.permit || 0) +
            Number(t.others || 0) +
            Number(t.escort_amount || 0);
        });

        const customerDetails = customers.find(
          (c) => c.customerid == form.customerid
        );

        const bank = mapBankDetails(clientBanks || []);

        let termsList = [];
        try {
          const termsRes = await axiosInstance.get("/api/terms", {
            params: {
              client_id: clientId,
              document_type: "invoice",
            },
          });

          termsList = termsRes.data?.terms || [];
        } catch (err) {
          console.error("⚠️ Could not load terms:", err);
          termsList = [];
        }

        // =========================
        // ⭐ Dynamic Row Title Logic
        // =========================
        let rowTitleDays = "Days";
        let rowTitleHours = "Hours";
        let rowTitleKms = "Kms";

        switch (form.billing_type) {
          case "Monthly Km Limit Month Rate":
            rowTitleHours = "Hours/Day";
            rowTitleKms = "Kms/Month";
            break;

          case "Monthly Hrs & Kms Limit Month Rate":
            rowTitleHours = "Hours/Month";
            rowTitleKms = "Kms/Month";
            break;

          case "Daily Km Limit Month Rate":
            rowTitleHours = "Hours/Day";
            rowTitleKms = "Kms/Day";
            break;

          case "Daily Km Limit Daily Rate":
            rowTitleHours = "Hours/Day";
            rowTitleKms = "Kms/Day";
            break;
        }

        const previewObject = {
          client: clientDetails,
          customer: customerDetails,
          rowTitles: {
            Days: rowTitleDays,
            Hours: rowTitleHours,
            Kms: rowTitleKms,
          },

          invoice: {
            number: invoiceData.invoice_number,
            date: invoiceData.invoice_date,
            po_no: invoiceData.po_no,
            reference: invoiceData.reference,
          },

          trips: mappedTrips,

          // ⭐ CONTRACT SUMMARY NEEDED BY HTML
          rows: form.contractRows,

          totals: {
            before_tax: form.gross_before_tax || 0,
            taxableamount: form.taxable_amount || 0,
            cgst: form.cgst_amount || 0,
            sgst: form.sgst_amount || 0,
            igst: form.igst_amount || 0,
            cgst_percent: form.cgst_percent || 0,
            sgst_percent: form.sgst_percent || 0,
            igst_percent: form.igst_percent || 0,
            fuel_escalation: form.fuel_esc_amount || 0,
            fuel_ex_remarks: form.fuel_ex_remarks || "",
            any_addition: form.addition_amount || 0,
            addition_remarks: form.addition_remarks || "",
            any_deduction: form.deduction_amount || 0,
            deduction_remarks: form.deduction_remarks || "",
            discount: form.discount_amount || 0,
            discount_percent: form.discount_percent || 0,

            // ORIGINAL ADVANCE (do not remove)
            advance:
              (form.advance_amount || 0) + (form.voucher_advance_amount || 0),

            net: netAmount || 0,
            word_amount: numberToIndianWords(netAmount || 0),

            // ------------------------
            // ⭐ MERGED totalsBreakup
            // ------------------------
            basic: basicTotal,
            batta: battaTotal,
            parking: parkingTotal,
            toll: tollTotal,
            permit: permitTotal,
            others: othersTotal,
            escort: escortTotal,

            // avoid overwriting totals.advance (the main advance)
            breakup_advance: advanceTotal,

            gross: grossTotal,
            net_breakup: netTotal, // optional, no collision
          },

          gst: {
            gst_treatment: form.gst_treatment,
            gst_treatment_id: form.gst_treatment_id,
            gst_notification: form.gst_notification,
            hsn_code: form.hsn_code,
          },

          totalsBreakup: {
            basic: basicTotal,
            batta: battaTotal,
            parking: parkingTotal,
            toll: tollTotal,
            permit: permitTotal,
            others: othersTotal,
            escort: escortTotal,
            advance: advanceTotal,
            net: netTotal,
            gross: grossTotal,
            advance: advanceTotal,
          },

          bank: bank,
          terms: termsList,
        };

        console.log("PREVIEW OBJECT:", previewObject);

        console.log(
          "FINAL PREVIEW OBJECT:",
          JSON.stringify(previewObject, null, 2)
        );

        try {
          const previewRes = await axiosInstance.post(
            "/api/invoice-template/preview/contract",
            previewObject
          );

          setPreviewHTML(previewRes.data.html);
          setPreviewData(previewObject);

          setTimeout(() => setShowPreview(true), 100);
        } catch (e) {
          console.error("Preview error:", e.response?.data || e);
          setSnackbar({
            open: true,
            message: "Preview generation failed",
            severity: "error",
          });
          return;
        }
      } catch (error) {
        console.error("Fatal error in handleSave:", error);
        setSnackbar({
          open: true,
          message:
            "Fatal error saving invoice: " + (error.message || "Unknown error"),
          severity: "error",
        });
      }
    } catch (outerError) {
      console.error("Unexpected error in handleSave:", outerError);
      setSnackbar({
        open: true,
        message: "Unexpected error saving invoice",
        severity: "error",
      });
    }
  };

  const handleCancel = () => {
    if (onCancel) onCancel(); // Notify parent to hide the form
    // Optionally reset form state here if needed
  };

  const denseCellStyle = {
    border: "1px solid #ccc",
    px: 1, // Tight horizontal padding
    py: 0.5, // Tight vertical padding
    fontSize: 13,
    minWidth: 70,
  };

  const fontSizeUnified = 16; // Set your preferred font size here
  const fieldHeight = "36px";
  const fieldFontSize = fontSizeUnified;
  const columnWidths = {
    // label: 200,
    // inputLarge: 360,
    // inputMedium: 222,
    // inputSmall: 240,

    label: 400,
    inputLarge: 300,
    inputMedium: 400,
    inputSmall: 200,
  };

  const inputSx = {
    fontSize: fieldFontSize,
    height: fieldHeight,
    "& .MuiInputBase-input": {
      paddingTop: "0px",
      paddingBottom: "0px",
      fontSize: fieldFontSize,
      height: fieldHeight,
      lineHeight: fieldHeight,
      textAlign: "right",
    },
  };

  const inputtext = {
    fontSize: fieldFontSize,
    height: fieldHeight,
    "& .MuiInputBase-input": {
      paddingTop: "0px",
      paddingBottom: "0px",
      fontSize: fieldFontSize,
      height: fieldHeight,
      lineHeight: fieldHeight,
      textAlign: "left",
    },
  };

  const UniversalField = ({ label, value, sx = {}, ...rest }) => (
    <TextField
      size="small"
      label={label}
      value={value}
      sx={{
        ...inputSx,
        width: "100%",
        "& .MuiInputBase-root": {
          height: fieldHeight, // fixed height
          minHeight: fieldHeight,
        },
        "& .MuiInputBase-input": {
          height: fieldHeight,
          lineHeight: fieldHeight,
          fontSize: fieldFontSize,
          textAlign: "right", // 🔥 FORCE RIGHT ALIGN
        },
        ...sx, // external styles allowed
      }}
      InputProps={{ readOnly: true }}
      {...rest}
    />
  );

  const safeValue = (v) =>
    typeof v === "number"
      ? v.toFixed(2)
      : !isNaN(parseFloat(v))
      ? parseFloat(v).toFixed(2)
      : "0.00";

  {
    /* ---------- FORMATTERS ---------- */
  }
  const formatTime = (t) => {
    if (!t) return "-";
    return t.toString().substring(0, 5); // HH:mm
  };

  const formatDate = (d) => {
    if (!d) return "";
    return new Date(d).toLocaleDateString("en-GB");
  };

  return (
    <Box sx={{ maxWidth: 1300, mx: "auto", mt: 4, mb: 4, p: 2 }}>
      {/* Header fields */}
      <Typography
        sx={{ fontWeight: "bold", color: "#226ad3", mb: 2, fontSize: 17 }}
      >
        Invoice Details
      </Typography>
      <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
        <TextField
          size="small"
          variant="outlined"
          name="number"
          label="Invoice Number"
          value={form.number}
          onChange={handleFieldChange}
          sx={{ minWidth: 180, background: "#fcfcfc" }}
        />
        <MyDatePicker
          label="Invoice Date"
          value={form.date}
          onChange={(date) => {
            const formattedDate = date ? date.toISOString().slice(0, 10) : "";
            setForm((prev) => ({ ...prev, date: formattedDate }));
          }}
          placeholder="DD/MM/YYYY"
          containerStyle={{ marginBottom: 0 }}
          inputStyle={{ minWidth: 160, background: "#fcfcfc" }}
          labelStyle={{ fontSize: 12 }}
        />

        <TextField
          size="small"
          variant="outlined"
          name="reference"
          label="Reference"
          value={form.reference}
          onChange={handleFieldChange}
          sx={{ minWidth: 160, background: "#fcfcfc" }}
        />
        <TextField
          size="small"
          variant="outlined"
          name="po_no"
          label="P.O. Number"
          value={form.po_no}
          onChange={handleFieldChange}
          sx={{ minWidth: 160, background: "#fcfcfc" }}
        />
        <TextField
          select
          size="small"
          variant="outlined"
          name="payment_mode"
          label="Mode"
          value={form.payment_mode}
          onChange={handleFieldChange}
          sx={{ minWidth: 220, background: "#fcfcfc" }}
        >
          <MenuItem value="">Select</MenuItem>
          {paymentModes.map((payment_mode) => (
            <MenuItem key={payment_mode} value={payment_mode}>
              {payment_mode}
            </MenuItem>
          ))}
        </TextField>
      </Box>
      <Box sx={{ display: "flex", gap: 2, mb: 1 }}>
        <FormControl size="small" sx={{ width: 655 }}>
          <InputLabel shrink>Customer</InputLabel>

          <CustomerDropdown
            customers={customers}
            selectedCustomerId={form.customerid}
            onChange={(val) => {
              const selected = customers.find(
                (c) => String(c.customerid) === String(val)
              );

              if (!selected) return;

              console.log("Selected customer:", selected);

              setForm((prev) => ({
                ...prev,
                customerid: selected.customerid,
                customerName: selected.customername,
                gst_treatment: selected.customergsttreament,
                tax_preference: selected.customertaxpreference,
                customergstin: selected.customergstin,
                place_of_supply: selected.customerplaceofsupply,
                cal_gst_parking_toll_permit:
                  selected.customerapplygstparkingtollpermit,
                cal_gst_batta: selected.customerapplygstbatta,
                cal_gst_others: selected.customerapplygstothers,
              }));

              // Trigger useEffect to fetch trip duties
              setSelectedCustomer(selected.customerid);

              // 🔥 FIX: Load duties immediately for NEW invoice
              if (!form.invoiceid || form.invoiceid === "0") {
                console.log("🟦 NEW invoice → loading duties...");
                handleAddDutyClick(); // <-- THIS FIXES YOUR ISSUE
              }
            }}
          />
        </FormControl>
        <TextField
          size="small"
          variant="outlined"
          name="customergstin"
          label="GSTIN"
          value={form.customergstin || ""}
          InputProps={{ readOnly: true }}
          sx={{ minWidth: 160, background: "#fcfcfc", mr: 0 }}
        />
        <TextField
          size="small"
          variant="outlined"
          name="place_of_supply"
          label="Place of Supply"
          value={form.place_of_supply || ""}
          InputProps={{ readOnly: true }}
          sx={{ minWidth: 160, background: "#fcfcfc", mr: 0 }}
        />
      </Box>

      {/* Contract Tariff Panel */}
      <Box sx={{ mt: 3, mb: 2 }}>
        <ContractTariffPanel
          clientId={clientId}
          customerId={form.customerid}
          selectedDuties={selectedDuties}
          /* ⭐ LOAD FROM invoices_contract TABLE */
          editBillingType={invoiceContract?.contract_bill_type || null}
          // editBillingType={invoiceContract?.billing_type}

          editVehicleId={invoiceContract?.vehicle_id || null}
          editVehicleGroupId={invoiceContract?.vehicle_group_id || null}
          editFromDate={invoiceContract?.from_date || null}
          editToDate={invoiceContract?.to_date || null}
          /* ⭐ REBUILD CONTRACT ROWS FOR PANEL */
          editRows={
            invoiceContract
              ? {
                  Days: {
                    limit: Number(invoiceContract.limit_days || 0),
                    actual: Number(invoiceContract.customer_days || 0),
                    extra: Number(invoiceContract.customer_extra_days || 0),
                    rate: Number(invoiceContract.limit_day_charges || 0),
                    total: Number(invoiceContract.limit_charges || 0),
                  },
                  Hours: {
                    limit: Number(invoiceContract.limit_hrs || 0),
                    actual: Number(invoiceContract.customer_hrs || 0),
                    extra: Number(invoiceContract.customer_extra_hrs || 0),
                    rate: Number(invoiceContract.limit_extra_hr_rate || 0),
                    total: Number(
                      invoiceContract.customer_extra_hrs_amount || 0
                    ),
                  },
                  Kms: {
                    limit: Number(invoiceContract.limit_kms || 0),
                    actual: Number(invoiceContract.customer_kms || 0),
                    extra: Number(invoiceContract.customer_extra_kms || 0),
                    rate: Number(invoiceContract.limit_extra_km_rate || 0),
                    total: Number(
                      invoiceContract.customer_extra_kms_amount || 0
                    ),
                  },
                }
              : null
          }
          /* ⭐ IMPORTANT — FIX DUTY SUMMARY NOT UPDATING */
          rows={rows} // ← ← ← ADD THIS LINE ✔✔✔
          /* Panel needs master data */
          vehicles={vehicles}
          vehicleGroups={vehicleGroups}
          /* Form management */
          form={form}
          setForm={setForm}
          onTariffChange={(data) => {
            const rows = data.rows;

            const basicAmount =
              Number(rows.Days?.total || 0) +
              Number(rows.Hours?.total || 0) +
              Number(rows.Kms?.total || 0);

            console.log("🔥 BASIC AMOUNT CALCULATED:", basicAmount);

            setContractTotals(rows);

            // ⭐ Sync the value to form (if needed later)
            setForm((prev) => ({
              ...prev,
              contractRows: rows,
              basic_amount: basicAmount,
            }));

            // ⭐ MOST IMPORTANT — sync to MAIN variable
            setBasic_amount(basicAmount);
          }}
        />
      </Box>

      {/* filter section */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 4, mb: 0 }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "0.875rem" }}>
          Filter By:
        </Typography>
        <RadioGroup row value={filterType} onChange={handleFilterChange}>
          <FormControlLabel
            value="all"
            control={<Radio size="small" />}
            label="All"
            sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.875rem" } }}
          />
          <FormControlLabel
            value="date"
            control={<Radio size="small" />}
            label="Date"
            sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.875rem" } }}
          />
        </RadioGroup>

        {filterType === "date" && (
          <Stack direction="row" spacing={2}>
            <MyDatePicker
              label="From"
              value={fromDate}
              onChange={(date) => setFromDate(date)}
              containerStyle={{ marginBottom: 0 }}
              inputStyle={{ minWidth: 140 }}
              labelStyle={{ fontSize: 12 }}
            />
            <MyDatePicker
              label="To"
              value={toDate}
              onChange={(date) => setToDate(date)}
              containerStyle={{ marginBottom: 0 }}
              inputStyle={{ minWidth: 140 }}
              labelStyle={{ fontSize: 12 }}
            />
          </Stack>
        )}
      </Box>

      {/* ----- Table Section ------- */}

      <Box
        sx={{
          mt: 1,
          border: "1px solid #ddd",
          overflowX: "auto",
          borderRadius: 1,
        }}
      >
        {isEditMode && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
            <Button
              variant="contained"
              size="small"
              onClick={handleAddDutyClick}
            >
              +Duty
            </Button>
          </Box>
        )}

        {/* ---------- TABLE ---------- */}
        <Table
          size="small"
          stickyHeader
          sx={{
            borderCollapse: "collapse",
            borderRadius: "8px",

            "& th": {
              background: "#e8e8e8ff",
              fontWeight: "bold",
              fontSize: "12px",
              padding: "2px 4px",
              height: "16px",
              lineHeight: "16px",
              borderRight: "1px solid #cecdcdff",
              textAlign: "center",
            },

            "& td": {
              fontSize: "13px",
              border: "1px solid #cecdcdff",
            },

            // ⭐⭐⭐ REDUCE ONLY BODY ROW HEIGHT
            "& tbody td": {
              padding: "2px 4px !important",
              lineHeight: "14px !important",
              height: "20px !important",
            },
            "& tbody tr": {
              height: "20px !important",
            },
          }}
        >
          <TableHead>
            {/* === GROUPED HEADER ROW === */}
            <TableRow>
              {/* Checkbox */}
              <TableCell
                rowSpan={2}
                padding="none"
                sx={{ width: 40, textAlign: "center" }}
              >
                <Checkbox
                  size="small"
                  checked={selectedAll}
                  onChange={handleSelectAll}
                />
              </TableCell>

              <TableCell rowSpan={2} sx={{ width: 100 }}>
                TS No
              </TableCell>
              <TableCell rowSpan={2} sx={{ width: 100 }}>
                Veh No
              </TableCell>
              <TableCell rowSpan={2} sx={{ width: 90 }}>
                Veh Group
              </TableCell>

              <TableCell colSpan={2} sx={{ width: 160, textAlign: "center" }}>
                Dates
              </TableCell>
              <TableCell colSpan={2} sx={{ width: 120, textAlign: "center" }}>
                Timings
              </TableCell>
              <TableCell colSpan={2} sx={{ width: 140, textAlign: "center" }}>
                Km Readings
              </TableCell>
              <TableCell colSpan={2} sx={{ width: 120, textAlign: "center" }}>
                Usage
              </TableCell>

              <TableCell rowSpan={2} sx={{ width: 60 }} align="right">
                Fuel
              </TableCell>
              <TableCell rowSpan={2} sx={{ width: 60 }} align="right">
                Escort
              </TableCell>
              <TableCell rowSpan={2} sx={{ width: 60 }} align="right">
                Parking
              </TableCell>
              <TableCell rowSpan={2} sx={{ width: 60 }} align="right">
                Toll
              </TableCell>
              <TableCell rowSpan={2} sx={{ width: 60 }} align="right">
                Permit
              </TableCell>
              <TableCell rowSpan={2} sx={{ width: 60 }} align="right">
                Others
              </TableCell>
            </TableRow>

            {/* === SUB HEADERS === */}
            <TableRow>
              {/* Dates */}
              <TableCell sx={{ width: 80 }}>Open</TableCell>
              <TableCell sx={{ width: 80 }}>Close</TableCell>

              {/* Timings */}
              <TableCell sx={{ width: 60 }}>Open</TableCell>
              <TableCell sx={{ width: 60 }}>Close</TableCell>

              {/* KM Readings */}
              <TableCell sx={{ width: 70 }}>Open</TableCell>
              <TableCell sx={{ width: 70 }}>Close</TableCell>

              {/* Usage */}
              <TableCell sx={{ width: 60 }} align="right">
                Hours
              </TableCell>
              <TableCell sx={{ width: 60 }} align="right">
                Kms
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row, idx) => (
              <TableRow key={`${row.trip_duty_id}-${idx}`} hover>
                {/* Checkbox */}
                <TableCell
                  padding="none"
                  sx={{ width: 36, textAlign: "center" }}
                >
                  <Checkbox
                    size="small"
                    checked={selectedIndex.includes(idx)}
                    onChange={() => handleSelectRow(idx)}
                  />
                </TableCell>

                <TableCell>{row.tripsheet_number}</TableCell>
                <TableCell>{row.vehicleid || "-"}</TableCell>
                <TableCell>{row.assigned_vehicle_group_name}</TableCell>

                {/* Dates */}
                <TableCell sx={{ textAlign: "left" }}>
                  {formatDate(row.open_date)}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {formatDate(row.close_date)}
                </TableCell>

                {/* Times */}
                <TableCell align="right">{formatTime(row.open_time)}</TableCell>
                <TableCell align="right">
                  {formatTime(row.close_time)}
                </TableCell>

                {/* KM Readings */}
                <TableCell align="right">
                  {row.open_km_reading ?? "-"}
                </TableCell>
                <TableCell align="right">
                  {row.close_km_reading ?? "-"}
                </TableCell>

                {/* Usage */}
                <TableCell align="right">
                  {row.trip_charges_hours_used ?? "-"}
                </TableCell>
                <TableCell align="right">
                  {row.trip_charges_kms_used ?? "-"}
                </TableCell>

                {/* Charges */}
                <TableCell align="right">
                  {safeValue(row.trip_charges_fuel_esculation_amount)}
                </TableCell>

                <TableCell align="right">
                  {safeValue(row.trip_charges_escort_amount)}
                </TableCell>

                <TableCell align="right">
                  {safeValue(row.trip_charges_parking)}
                </TableCell>

                <TableCell align="right">
                  {safeValue(row.trip_charges_toll_fasttag)}
                </TableCell>

                <TableCell align="right">
                  {safeValue(row.trip_charges_permit)}
                </TableCell>

                <TableCell align="right">
                  {safeValue(row.trip_charges_others)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>

      {/* ===================== +Voucher Button (Top Right) ===================== */}
      {form.customerid && (
        <Box sx={{ textAlign: "right", mt: 1 }}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleOpenVoucherTable}
            sx={{ fontWeight: "bold" }}
          >
            + Voucher
          </Button>
        </Box>
      )}

      {/* ===================== VOUCHER TABLE ===================== */}
      {showVoucherTable && (
        <Box
          sx={{
            mt: 2,
            border: "1px solid #d0d0d0",
            borderRadius: "6px",
            background: "#fff",
            p: 2,
            overflow: "visible !important",
          }}
        >
          {/* ---------- HEADER WITH +Voucher on Right ---------- */}

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: "16px",
                color: "#333",
              }}
            >
              Select Advance Vouchers
            </Typography>

            {/* ❌ Light simple close icon */}
            <CloseIcon
              onClick={() => setShowVoucherTable(false)}
              sx={{
                cursor: "pointer",
                color: "#999", // light grey
                fontSize: "22px",
                "&:hover": {
                  color: "#555", // slightly darker on hover
                },
              }}
            />
          </Box>

          <Table
            size="small"
            sx={{
              minWidth: 700,
              border: "1px solid #e0e0e0",
              "& th": {
                background: "#f5f5f5",
                fontWeight: "bold",
                fontSize: "14px",
                padding: "4px",
                borderRight: "1px solid #ddd",
                textAlign: "left",
              },
              "& td": {
                padding: "1px",
                fontSize: "14px",
                borderBottom: "1px solid #eee",
                borderRight: "1px solid #f0f0f0",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  padding="none"
                  sx={{
                    border: "1px solid #ddd",
                    width: 36,
                    height: 36,
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  <Checkbox
                    checked={voucherSelectAll}
                    onChange={handleVoucherSelectAll}
                    sx={{
                      padding: "2px",
                      "& .MuiSvgIcon-root": {
                        fontSize: "20px",
                      },
                    }}
                  />
                </TableCell>

                <TableCell>Voucher No</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Open Time</TableCell>
                <TableCell>Close Time</TableCell>
                <TableCell>Open KM</TableCell>
                <TableCell>Close KM</TableCell>
                <TableCell align="right">Hours</TableCell>
                <TableCell align="right">Kms</TableCell>
                <TableCell>Narration</TableCell>
                <TableCell align="right">Advance Amount</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {vouchers.map((v) => {
                const vid = Number(v.voucher_id ?? v.id);

                // ⭐ FORMAT TIME TO HH:mm
                const formatTime = (t) => (t ? t.substring(0, 5) : "-"); // handles "HH:mm:ss"

                return (
                  <TableRow
                    key={vid}
                    hover
                    selected={selectedVoucherIds.includes(vid)}
                    sx={{
                      cursor: "pointer",
                      "&.Mui-selected": {
                        backgroundColor: "#e8f4ff !important",
                      },
                    }}
                    onClick={(e) => {
                      if (e.target.closest(".voucher-checkbox")) return;
                      handleVoucherSelect(vid);
                    }}
                  >
                    <TableCell
                      padding="none"
                      sx={{
                        border: "1px solid #ddd",
                        width: 36,
                        height: 36,
                        verticalAlign: "middle",
                        textAlign: "center",
                      }}
                    >
                      <Checkbox
                        className="voucher-checkbox"
                        checked={selectedVoucherIds.includes(vid)}
                        onChange={() => handleVoucherSelect(vid)}
                        inputProps={{ "aria-label": `select-voucher-${vid}` }}
                        sx={{
                          padding: "2px",
                          "& .MuiSvgIcon-root": { fontSize: "20px" },
                        }}
                      />
                    </TableCell>

                    {/* LEFT ALIGN FIELDS */}
                    <TableCell>{v.voucher_number}</TableCell>

                    <TableCell>
                      {new Date(v.voucher_date).toLocaleDateString("en-GB")}
                    </TableCell>

                    {/* TIME FIELDS → RIGHT ALIGN */}
                    <TableCell align="right">
                      {formatTime(v.open_time)}
                    </TableCell>
                    <TableCell align="right">
                      {formatTime(v.close_time)}
                    </TableCell>

                    {/* NUMERIC → RIGHT ALIGN */}
                    <TableCell align="right">
                      {v.open_km_reading ?? "-"}
                    </TableCell>
                    <TableCell align="right">
                      {v.close_km_reading ?? "-"}
                    </TableCell>

                    <TableCell align="right">{v.used_hours ?? "-"}</TableCell>
                    <TableCell align="right">{v.used_kms ?? "-"}</TableCell>

                    {/* TEXT */}
                    <TableCell>{v.narration}</TableCell>

                    {/* AMOUNT → RIGHT ALIGN */}
                    <TableCell align="right">
                      {Number(v.credit_amount || 0).toFixed(2)}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Box>
      )}

      {/* ------------Summary----------------- */}
      <Box
        sx={{
          mt: 2,
          mb: 4,
          px: 3,
          py: 10,
          maxWidth: 1260,
          background: "#fff",
          borderRadius: 3,
          boxShadow: 2,
          // overflowY: "auto",              // Enables vertical scrolling
          // overflowX: "hidden",            // Hides horizontal overflow
        }}
      >
        {/* Top row */}
        <Stack direction="row" alignItems="center" spacing={0} mb={2}>
          <Box sx={{ width: columnWidths.inputLarge, mr: 2 }}>
            <UniversalField
              label="GST Treatment"
              value={form.gst_treatment}
              sx={{ ...inputtext, width: "100%" }}
            />
          </Box>
          <Box sx={{ width: columnWidths.inputSmall }}>
            <UniversalField
              label="Tax Preference"
              value={form.tax_preference}
              sx={{ ...inputtext, width: "100%" }}
            />
          </Box>
          <Box sx={{ width: columnWidths.inputSmall, ml: 2 }}>
            <UniversalField
              label="HSN Code"
              value={hsn_code}
              sx={{ ...inputtext, width: "100%" }}
            />
          </Box>
          <Box sx={{ width: columnWidths.inputSmall, ml: 2 }} />
        </Stack>

        {/* Charges rows */}
        <Stack spacing={0.5}>
          {[
            { label: "Basic Amount", value: basic_amount ?? 0 },
            { label: "Fuel Escalation", value: fuel_esc_amount },
            { label: "Escort", value: escort_amount },
            { label: "Batta", value: batta_amount, gstField: "cal_gst_batta" },
            {
              label: "Parking",
              value: parking_amount,
              gstField: "cal_gst_parking_toll_permit",
            },
            {
              label: "Toll",
              value: toll_amount,
              gstField: "cal_gst_parking_toll_permit",
            },
            {
              label: "Permit",
              value: permit_amount,
              gstField: "cal_gst_parking_toll_permit",
            },
            {
              label: "Others",
              value: others_amount,
              gstField: "cal_gst_others",
            },
          ].map(({ label, value, gstField }) => (
            <Stack direction="row" alignItems="center" spacing={0} key={label}>
              <Box sx={{ width: columnWidths.label }}>
                <Typography sx={{ fontSize: fieldFontSize }}>
                  {label}
                </Typography>
              </Box>
              <Box sx={{ width: columnWidths.inputLarge }} />
              <Box
                sx={{
                  width: columnWidths.inputMedium,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                {gstField ? (
                  <TextField
                    size="small"
                    variant="outlined"
                    value={form[gstField] || ""}
                    placeholder="Yes / No"
                    InputProps={{ readOnly: true }}
                    sx={{
                      width: 100,
                      mr: 4,
                      "& .MuiInputBase-root": {
                        height: "32px",
                        minHeight: "32px",
                      },
                      "& .MuiInputBase-input": {
                        textAlign: "center",
                        fontSize: fieldFontSize - 2,
                        padding: "0 4px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#bbb",
                      },
                    }}
                    InputLabelProps={{ shrink: false }}
                    inputProps={{ style: { textAlign: "center" } }}
                  />
                ) : null}
              </Box>
              <Box sx={{ width: columnWidths.inputSmall }}>
                <UniversalField value={safeValue(value)} />
              </Box>
            </Stack>
          ))}
        </Stack>

        {/* Any Addition Charges */}
        <Stack direction="row" alignItems="center" spacing={0} sx={{ mt: 0.5 }}>
          <Box sx={{ width: columnWidths.label }}>
            <Typography sx={{ fontSize: fieldFontSize }}>
              Any Addition Charges
            </Typography>
          </Box>
          <Box sx={{ width: columnWidths.inputLarge }}>
            <TextField
              size="small"
              sx={{
                ...inputSx,
                width: "100%",
                "& .MuiInputBase-root": {
                  height: fieldHeight,
                  minHeight: fieldHeight,
                },
                "& .MuiOutlinedInput-root": {
                  padding: 0,
                  minHeight: fieldHeight,
                },
                "& .MuiInputBase-input": {
                  textAlign: "left",
                  height: fieldHeight,
                  padding: "0 8px",
                },
              }}
              placeholder="Addition Remarks"
              value={form.addition_remarks || ""}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  addition_remarks: e.target.value,
                }))
              }
              inputProps={{ style: { fontSize: fieldFontSize } }}
            />
          </Box>
          <Box sx={{ width: columnWidths.inputMedium }} />
          <Box sx={{ width: columnWidths.inputSmall }}>
            <TextField
              size="small"
              sx={{
                ...inputSx,
                width: "100%",
                "& .MuiInputBase-root": {
                  height: fieldHeight,
                  minHeight: fieldHeight,
                },
                "& .MuiInputBase-input": {
                  textAlign: "right",
                  fontSize: fieldFontSize,
                  MozAppearance: "textfield", // Hide Firefox spinners
                  "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button":
                    {
                      // Hide Chrome/Edge/Safari spinners
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                },
              }}
              type="number"
              step="0.01"
              value={
                form.addition_amount != null
                  ? (Number(form.addition_amount) || 0).toFixed(2)
                  : "0.00"
              }
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  addition_amount: parseFloat(e.target.value) || 0,
                }))
              }
              inputProps={{ style: { fontSize: fieldFontSize } }}
            />
          </Box>
        </Stack>

        {/* Discount (on Basic Amount) */}
        <Stack direction="row" alignItems="center" spacing={0} sx={{ mt: 0.5 }}>
          <Box sx={{ width: columnWidths.label }}>
            <Typography sx={{ fontSize: fieldFontSize }}>
              Discount (on Basic Amount)
            </Typography>
          </Box>
          <Box sx={{ width: columnWidths.inputLarge }}>
            <TextField
              size="small"
              sx={{
                ...inputSx,
                width: 185,
                "& .MuiInputBase-root": { height: "36px", minHeight: "36px" },
                "& .MuiInputBase-input": {
                  ...inputSx["& .MuiInputBase-input"],
                  textAlign: "right",
                },
              }}
              type="number"
              value={form.discount_percent || 0}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  discount_percent: Number(e.target.value) || 0,
                }))
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Typography
                      sx={{ fontWeight: "bold", fontSize: fieldFontSize }}
                    >
                      %
                    </Typography>
                  </InputAdornment>
                ),
              }}
              inputProps={{
                style: {
                  fontSize: fieldFontSize,
                  height: "36px",
                  textAlign: "right",
                },
              }}
            />
          </Box>
          <Box sx={{ width: columnWidths.inputMedium }} />
          <Box sx={{ width: columnWidths.inputSmall }}>
            <UniversalField
              value={
                form.discount_amount != null
                  ? (Number(form.discount_amount) || 0).toFixed(2)
                  : "0.00"
              }
            />
          </Box>
        </Stack>

        {/* Any Deduction */}
        <Stack direction="row" alignItems="center" spacing={0} sx={{ mt: 0.5 }}>
          <Box sx={{ width: columnWidths.label }}>
            <Typography sx={{ fontSize: fieldFontSize }}>
              Any Deduction
            </Typography>
          </Box>
          <Box sx={{ width: columnWidths.inputLarge }}>
            <TextField
              size="small"
              sx={{
                ...inputSx,
                width: "100%",
                "& .MuiInputBase-root": { height: "36px", minHeight: "36px" },
                "& .MuiOutlinedInput-root": { minHeight: "36px", padding: 0 },
                "& .MuiInputBase-input": {
                  fontSize: fieldFontSize,
                  height: "36px",
                  lineHeight: "36px",
                  padding: "0 8px",
                  textAlign: "left",
                },
              }}
              placeholder="Deduction Remarks"
              value={form.deduction_remarks || ""}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  deduction_remarks: e.target.value,
                }))
              }
              inputProps={{
                style: { fontSize: fieldFontSize, textAlign: "left" },
              }}
            />
          </Box>
          <Box sx={{ width: columnWidths.inputMedium }} />
          <Box sx={{ width: columnWidths.inputSmall }}>
            <TextField
              size="small"
              sx={{
                ...inputSx,
                width: "100%",
                "& .MuiInputBase-root": { height: "36px", minHeight: "36px" },
                "& .MuiInputBase-input": {
                  fontSize: fieldFontSize,
                  height: "36px",
                  lineHeight: "36px",
                  padding: "0 12px 0 0",
                  textAlign: "right",
                  MozAppearance: "textfield",
                  "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                },
              }}
              type="number"
              step="0.01"
              value={Number(form.deduction_amount).toFixed(2)}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  deduction_amount: parseFloat(e.target.value) || 0,
                }))
              }
              inputProps={{
                style: {
                  fontSize: fieldFontSize,
                  textAlign: "right",
                  height: "36px",
                  lineHeight: "36px",
                  padding: "0 12px 0 0",
                },
              }}
            />
          </Box>
        </Stack>

        {/* Amount before tax (Gross) */}
        <Stack direction="row" alignItems="center" spacing={0} sx={{ mt: 0.5 }}>
          <Box sx={{ width: columnWidths.label }}>
            <Typography sx={{ fontWeight: "bold", fontSize: fieldFontSize }}>
              {form.tax_preference === "Taxable"
                ? "Amount before tax (Gross)"
                : "Gross Amount"}
            </Typography>
          </Box>
          <Box sx={{ width: columnWidths.inputLarge }} />
          <Box sx={{ width: columnWidths.inputMedium }} />
          <Box sx={{ width: columnWidths.inputSmall }}>
            <TextField
              size="small"
              sx={{ ...inputSx, width: "100%", background: "#d3f5d7" }}
              value={
                form.gross_before_tax
                  ? form.gross_before_tax.toFixed(2)
                  : "0.00"
              }
              inputProps={{
                readOnly: true,
                style: {
                  fontSize: fieldFontSize,
                  height: fieldHeight,
                  textAlign: "right",
                },
              }}
            />
          </Box>
        </Stack>

        {/* Taxable Amount */}
        {form.tax_preference === "Taxable" && (
          <Stack
            direction="row"
            alignItems="center"
            spacing={0}
            sx={{ mt: 0.5 }}
          >
            <Box sx={{ width: columnWidths.label }}>
              <Typography sx={{ fontSize: fieldFontSize }}>
                Taxable Amount
              </Typography>
            </Box>
            <Box sx={{ width: columnWidths.inputSmall }}>
              <TextField
                size="small"
                sx={{ ...inputSx, width: "100%" }}
                value={
                  form.taxable_amount ? form.taxable_amount.toFixed(2) : "0.00"
                }
                inputProps={{
                  readOnly: true,
                  style: {
                    fontSize: fieldFontSize,
                    height: fieldHeight,
                    textAlign: "right",
                  },
                }}
              />
            </Box>
            <Box sx={{ width: columnWidths.inputLarge }} />
            <Box sx={{ width: columnWidths.inputMedium }} />
          </Stack>
        )}

        {/* GST Rows */}
        {form.tax_preference === "Taxable" &&
          (() => {
            const isRCM =
              form.gst_treatment === "Registered Business-Under RCM";

            const gstRows =
              form.place_of_supply === form.client_place_of_supply
                ? [
                    {
                      type: "CGST",
                      percent: form.cgst_percent,
                      amount: form.cgst_amount,
                    },
                    {
                      type: "SGST",
                      percent: form.sgst_percent,
                      amount: form.sgst_amount,
                    },
                  ]
                : [
                    {
                      type: "IGST",
                      percent: form.igst_percent,
                      amount: form.igst_amount,
                    },
                  ];

            return gstRows.map(({ type, percent, amount }) => (
              <Stack
                direction="row"
                alignItems="center"
                spacing={0}
                key={type}
                sx={{ mt: 0.5 }}
              >
                {/* LABEL */}
                <Box sx={{ width: columnWidths.label }}>
                  <Typography
                    sx={{
                      fontSize: fieldFontSize,
                      color: isRCM ? "red" : "inherit",
                    }}
                  >
                    {type}
                  </Typography>
                </Box>

                {/* PERCENT INPUT */}
                <Box sx={{ width: columnWidths.inputLarge }}>
                  <TextField
                    size="small"
                    name={
                      type === "CGST"
                        ? "cgst_percent"
                        : type === "SGST"
                        ? "sgst_percent"
                        : "igst_percent"
                    }
                    value={percent ?? ""}
                    onChange={handleFieldChange}
                    sx={{
                      ...inputSx,
                      width: 185,
                    }}
                    InputProps={{
                      sx: {
                        "& .MuiInputBase-input": {
                          color: isRCM ? "red" : "inherit", // 🔥 COLOR
                          textAlign: "right",
                        },
                      },
                      endAdornment: (
                        <Typography
                          sx={{
                            color: isRCM ? "red" : "text.secondary",
                            fontSize: fieldFontSize,
                            pr: 1,
                          }}
                        >
                          %
                        </Typography>
                      ),
                    }}
                  />
                </Box>

                {/* EMPTY MIDDLE */}
                <Box sx={{ width: columnWidths.inputMedium }} />

                {/* AMOUNT */}
                <Box sx={{ width: columnWidths.inputSmall }}>
                  <UniversalField
                    value={amount != null ? amount.toFixed(2) : "0.00"}
                    sx={{
                      "& .MuiInputBase-input": {
                        color: isRCM ? "red" : "inherit", // RCM color
                        textAlign: isRCM ? "left" : "right", // ⭐ ALIGN LEFT for RCM, RIGHT otherwise
                      },
                    }}
                  />
                </Box>
              </Stack>
            ));
          })()}

        {/* Advance and other amount rows */}
        <Stack spacing={0.5} sx={{ mt: 0.5 }}>
          {[
            { label: "Advance in Tripsheet", value: form.advance_amount },
            {
              label: "Advance in Receipts (On Account)",
              value: form.voucher_advance_amount,
            },
            { label: "Coin Adjust", value: form.coin_adjust },
            { label: "Net Amount", value: netAmount, highlight: true },
          ].map(({ label, value, highlight }) => (
            <Stack direction="row" alignItems="center" spacing={0} key={label}>
              <Box sx={{ width: columnWidths.label }}>
                <Typography
                  sx={{
                    fontSize: fieldFontSize,
                    fontWeight: highlight ? "bold" : "normal",
                  }}
                >
                  {label}
                </Typography>
              </Box>
              <Box sx={{ width: columnWidths.inputLarge }} />
              <Box sx={{ width: columnWidths.inputMedium }} />
              <Box sx={{ width: columnWidths.inputSmall }}>
                <TextField
                  size="small"
                  sx={{
                    ...inputSx,
                    width: "100%",
                    background: highlight ? "#d3f5d7" : undefined,
                    // Remove fontWeight here; style input separately
                  }}
                  value={value != null ? value.toFixed(2) : "0.00"}
                  inputProps={{
                    style: {
                      fontSize: fieldFontSize,
                      height: fieldHeight,
                      textAlign: "right",
                      fontWeight: highlight ? "bold" : "normal", // bold for input text
                    },
                    readOnly: true,
                  }}
                />
              </Box>
            </Stack>
          ))}
        </Stack>

        {/* Bottom Remarks */}
        <Stack direction="row" spacing={2} mt={3}>
          <TextField
            fullWidth
            size="small"
            multiline
            minRows={2}
            maxRows={2}
            label="GST Notification"
            name="gst_notification"
            value={form.gst_notification || ""}
            onChange={handleFieldChange}
            sx={{
              ...inputSx,
              minWidth: 220,
              fontSize: fieldFontSize,

              "& .MuiInputBase-input": {
                textAlign: "left",
                padding: "8px",
              },

              "& textarea": {
                textAlign: "left !important", // 🔥 Forces left alignment
              },
            }}
          />

          <TextField
            fullWidth
            size="small"
            label="Remarks"
            name="remarks"
            multiline
            minRows={2}
            maxRows={2}
            value={form.remarks || ""}
            onChange={handleFieldChange}
            sx={{
              ...inputSx,
              minWidth: 220,
              fontSize: fieldFontSize,

              "& .MuiInputBase-input": {
                textAlign: "left",
                padding: "8px",
              },

              "& textarea": {
                textAlign: "left !important", // 🔥 Forces left alignment
              },
            }}
          />
        </Stack>
      </Box>

      <Box
        sx={{ display: "flex", justifyContent: "flex-start", mt: 3, gap: 2 }}
      >
        <Button variant="contained" color="primary" onClick={handleSave}>
          {form.invoiceid && form.invoiceid !== "new" ? "Update" : "Save"}
        </Button>
        <Button variant="outlined" color="secondary" onClick={handleCancel}>
          Cancel
        </Button>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>

      {showPreview && previewHTML && (
        <PreviewModal
          open={showPreview}
          onClose={() => handlePreviewClose()}
          html={previewHTML}
          invoiceData={previewData}
          mode="contract"
          showSnackbar={(snack) =>
            setSnackbar({
              open: true,
              message: snack.message,
              severity: snack.severity,
            })
          }
        />
      )}
    </Box>
  );
}
